import {
	ROUTE_CREATE_OFFER_SIMULATOR,
	ROUTE_CREATE_OFFER_LOGIN,
	ROUTE_CREATE_OFFER_BANK_DETAILS,
	ROUTE_CREATE_OFFER_CREDIT_CARD,
	ROUTE_CREATE_OFFER_FINISHED
} from "./constants";

// Exemplo: OfferStatus[2], retorna "Ativa"
export const OfferStatus = {
	1: "Em análise",
	6: "Em análise",
	2: "Ativa",
	3: "Em venda",
	4: "Inativa",
	5: "Pendente",
	7: "Reanálise",
	EM_ANALISE: 1,
	ATIVA: 2,
	EM_VENDA: 3,
	INATIVA: 4,
	PENDENTE: 5,
	REANALISE: 7
};

export const OfferSubStatus = {
	ATIVO_LIBERADO: 5,
	INATIVO_TELEFONE_LATAM: 23,
	REANALISE_PENDENCIA_OFERTA: 31
}

export const OfferColorStatus = {
	1: "yellow",
	6: "yellow",
	2: "green",
	3: "blue",
	4: "grey",
	5: "yellow"
};

export const OfferInfo = {
	1: "Neste momento estamos analisando as informações da sua oferta. Em até 48 horas a análise será concluída.",
	2: "As suas milhas já estão disponíveis para venda. Caso não esteja vendendo, sugerimos que reveja o valor das suas milhas.",
	3: "Neste momento estamos utilizando suas milhas para a emissão de uma passagem. Portanto, não é possível editar a oferta. ",
	4: "Infelizmente suas milhas estão indisponíveis para venda. Sugerimos que altere sua oferta para ativá-las."
};

// Exemplo: PriceStateStatus[1], retorna "Venda Rápida"
export const PriceStateStatus = {
	1: "Venda rápida",
	2: "Venda lenta"
};
// Exemplo: PriceStateStatus[1], retorna "Venda Rápida"
export const PriceColorStatus = {
	green: "Venda rápida",
	red: "Venda lenta",
	orange: "Pode demorar alguns dias"
};

export const CreateOfferSequence = {
	1: ROUTE_CREATE_OFFER_SIMULATOR,
	2: ROUTE_CREATE_OFFER_LOGIN,
	3: ROUTE_CREATE_OFFER_BANK_DETAILS,
	4: ROUTE_CREATE_OFFER_CREDIT_CARD,
	5: ROUTE_CREATE_OFFER_FINISHED
};

export const CreditCardDefaultFormat = /(\d{1,4})/g;

export const CreditCards = {
	visa: {
		brand: "visa",
		pattern: /^4/,
		format: CreditCardDefaultFormat,
		length: [13, 16],
		cvcLength: [3],
		mask: "9999 9999 9999 9999"
	},
	mastercard: {
		brand: "mastercard",
		pattern: /^(5[1-5]|2[2-7])/,
		format: CreditCardDefaultFormat,
		length: [16],
		cvcLength: [3],
		mask: "9999 9999 9999 9999"
	},
	amex: {
		brand: "amex",
		pattern: /^3[47]/,
		format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
		length: [15],
		cvcLength: [4],
		mask: "9999 999999 99999"
	},
	dinners: {
		brand: "dinners",
		pattern: /^3[0689]/,
		format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
		length: [14],
		cvcLength: [3],
		mask: "9999 999999 9999"
	},
	elo: {
		brand: "elo",
		pattern: /^((431274)|(506717)|(506718)|(506733)|(506739)|(506774)|(506776)|(506778)|(509013)|(509033)|(509064)|(636297)|(401178)|(401179)|(438935)|(457393)|(457631)|(457632)|(504175)|(506720)|(506721)|(506740)|(506753)|(506775)|(506777)|(509072)|(509074)|(509076)|(636368)|(506707)|(506708)|(506715)|(506719)|(509012)|(509032)|(509034)|(509070)|(509071)|(509075)|(509084)|(?:50908[5-9]|50909[0-9]|509[1-7][0-9][0-9]|50980[0-9]|509810)|(?:65090[1-9]|65091[0-9]|650920)|(?:65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(?:65054[1-9]|6505[5-8][0-9]|65059[0-8])|(?:65070[0-9]|65071[0-8])|(?:65072[0-7])|(?:65165[2-9]|6516[6-7][0-9])|(?:65500[0-9]|65501[0-9])|(?:65502[1-9]|6550[3-4][0-9]|65505[0-8])|(?:65040[5-9]|6504[1-3][0-9])|(?:50674[1-3])|(?:50900[4-9])|(?:50902[0-9]|50903[0-1])|(?:50903[5-9]|50904[0-9]|50905[0-3])|(?:50907[7-9]|509080)|(?:50672[4-9]|50673[0-2])|(?:50674[4-8])|(?:50900[0-2])|(?:50906[6-9])|(?:50908[1-3])|(?:50675[0-2])|(?:50901[4-9])|(?:50905[4-9]|50906[0-3]))/,
		format: CreditCardDefaultFormat,
		length: [16],
		cvcLength: [3],
		mask: "9999 9999 9999 9999"
	},
	hipercard: {
		brand: "hipercard",
		pattern: /^(606282|3841[046]0)/,
		format: CreditCardDefaultFormat,
		length: [13, 16, 19],
		cvcLength: [3],
		mask: "9999 9999 9999 9999 999"
	},
	/*discover: {
		brand: "discover",
		pattern: /^6([045]|22)/,
		format: CreditCardDefaultFormat,
		length: [16],
		cvcLength: [3]
	},*/
	aura: {
		brand: "aura",
		pattern: /^50/,
		format: CreditCardDefaultFormat,
		length: [17],
		cvcLength: [3],
		mask: "9999 9999 9999 9999 9"
	}
};

export const CreditCardsRelation = {
	VISA: CreditCards.visa,
	"MASTER CARD": CreditCards.mastercard,
	"MASTER CARD - Super Conta": CreditCards.mastercard,
	AMEX: CreditCards.amex,
	"DINNERS CLUB": CreditCards.dinners,
	AURA: CreditCards.aura,
	ELO: CreditCards.elo,
	HIPERCARD: CreditCards.hipercard
};

export const mmPhones = {
	phone11: ["(11) 99710-0285", "(11) 95063-5316", "(11) 94343-5043", "(11) 93293-7244", "(11) 93298-3476", "(11) 94266-7386", "(11) 94378-6346", "(11) 99907-3689"],
	phone12: ["(12) 99670-6926"],
	phone13: ["(13) 99785-5537"],
	phone16: ["(16) 99962-2567"],
	phone19: ["(19) 99886-5746", "(19) 97148-7559"],

	phone21: ["(21) 99598-9685", "(21) 99538-4407", "(21) 99610-8819"],
	phone22: ["(22) 99710-2408", "(22) 99749-7448", "(22) 99864-6788"],
	phone24: ["(24) 99916-9459"],
	phone27: ["(27) 99530-4730"],
	phone28: ["(28) 99942-1919", "(28) 99989-0898"],

	phone31: ["(31) 99660-6424", "(31) 99990-6279", "(31) 99807-4804", "(31) 99562-8089", "(31) 99167-5459", "(31) 99191-5661", "(31) 99148-0647"],
	phone33: ["(33) 99808-6763"],
	phone34: ["(34) 99930-8065"],
	phone35: ["(35) 99893-0699"],

	phone41: ["(41) 99263-9235", "(41) 99286-4330", "(41) 99206-8630"],
	phone43: ["(43) 99164-8697", "(43) 99870-9373"],
	phone44: ["(44) 99159-5651"],
	phone45: ["(45) 99148-3427", "(45) 99138-0528", "(45) 99118-6029", "(45) 99118-6029"],
	phone47: ["(47) 99203-3540", "(47) 99220-6134"],
	phone48: ["(48) 99171-3340"],

	phone51: ["(51) 99697-7931", "(51) 99697-2884", "(51) 99707-2080", "(51) 99783-9535", "(51) 99539-5959", "(51) 99672-5107", "(51) 99796-0991"],
	phone55: ["(55) 99929-7080", "(55) 99948-0546"],

	phone61: ["(61) 99854-3418", "(61) 99821-2567", "(61) 99684-9346", "(61) 99643-2334"],
	phone62: ["(62) 99637-7743"],
	phone65: ["(65) 99683-7553"],
	phone69: ["(69) 99603-3356", "(69) 99988-0769"],

	phone71: ["(71) 99948-1771", "(71) 99993-1752", "(71) 99675-6388"],
	phone73: ["(73) 99927-0417", "(73) 99858-6046"],
	phone74: ["(74) 99985-2863"],
	phone77: ["(77) 99918-4198"],

	phone81: ["(81) 97118-2233", "(81) 98230-5678"],
	phone82: ["(82) 98144-8582"],
	phone83: ["(83) 98200-4455"],
	phone85: ["(85) 98118-4991", "(85) 98170-3721", "(85) 98174-6073"],
	phone86: ["(86) 98150-3171"],
	phone87: ["(87) 98100-4936", "(87) 98149-0208"],
	phone88: ["(88) 98128-1711"],

	phone91: ["(91) 99395-3355", "(91) 99366-2747", "(91) 99370-1070", "(91) 99281-5250"],
	phone92: ["(92) 99495-0461"],
	phone96: ["(96) 99187-5515"],
	phone98: ["(98) 99180-5738", "(98) 99149-4817", "(98) 99180-5738"],
	phone99: ["(99) 99224-8583"]
};

export const mmStatePhone = {
	AC: mmPhones.phone91,
	AL: mmPhones.phone82,
	AP: mmPhones.phone96,
	AM: mmPhones.phone92,
	BA: mmPhones.phone71.concat(mmPhones.phone73, mmPhones.phone74, mmPhones.phone77),
	CE: mmPhones.phone85.concat(mmPhones.phone88),
	DF: mmPhones.phone61,
	ES: mmPhones.phone28.concat(mmPhones.phone27),
	GO: mmPhones.phone62,
	MA: mmPhones.phone98.concat(mmPhones.phone99),
	MT: mmPhones.phone65,
	MG: mmPhones.phone31.concat(mmPhones.phone33, mmPhones.phone34, mmPhones.phone35),
	PA: mmPhones.phone91,
	PB: mmPhones.phone83,
	PR: mmPhones.phone41.concat(mmPhones.phone43, mmPhones.phone44, mmPhones.phone45),
	PE: mmPhones.phone81.concat(mmPhones.phone87),
	PI: mmPhones.phone86,
	RJ: mmPhones.phone21.concat(mmPhones.phone22, mmPhones.phone24),
	RN: mmPhones.phone85,
	RS: mmPhones.phone51.concat(mmPhones.phone55),
	RO: mmPhones.phone69,
	RR: mmPhones.phone91,
	SC: mmPhones.phone47.concat(mmPhones.phone48),
	SP: mmPhones.phone11.concat(mmPhones.phone12, mmPhones.phone13, mmPhones.phone16, mmPhones.phone19),
	SE: mmPhones.phone98,
	TO: mmPhones.phone91
};

export const MonthsPTBR = {
	1: "Janeiro",
	2: "Fevereiro",
	3: "Março",
	4: "Abril",
	5: "Maio",
	6: "Junho",
	7: "Julho",
	8: "Agosto",
	9: "Setembro",
	10: "Outubro",
	11: "Novembro",
	12: "Dezembro"
};

export const NationalAirlines = {
	3: {
		name: "Latam Pass",
		company: "Latam"
	},
	// 1: {
	// 	name: "Platinum / Black",
	// 	company: "Latam"
	// },
	4: {
		name: "Smiles",
		company: "Gol"
	},
	5: {
		name: "Tudo Azul",
		company: "Azul"
	}
};

// VARIAVEIS DO BONUS DA LATAM, verificar o método isBonusAvailable do SimulatorMiles
//export const LATAM_BONUS_END_DATE = "2019/04/19 14:00:00 GMT-0300"; // Se o bônus for até dia 10/01/2019, a data precisa respeitar o formato
//export const LATAM_BONUS_LABEL_DATE = "Até 18/04/19"; // Texto exibido em destaque no entenda o bônus, essa data exibe no padrão 10/01/19
export const LATAM_BONUS_MAX_PRICE = 33.5; // Valor de bônus que atualmente é de R$ 20,00
export const LATAM_BONUS_START_AVERAGE = 6500; // Se alterar essa variável terá que ajustar o layout do Slider pra ficar posicionado correto
export const LATAM_BONUS_END_AVERAGE = 15000; // Se alterar essa variável terá que ajustar o layout do Slider pra ficar posicionado correto
export const LATAM_BONUS_BEST_AVERAGE = 10000;

// VARIAVEIS DO BONUS DA GOL
//export const GOL_BONUS_END_DATE = "2019/04/29 14:00:00 GMT-0300"; // Se o bônus for até dia 10/01/2019, a data precisa respeitar o formato
//export const GOL_BONUS_LABEL_DATE = "Até 29/04/19"; // Texto exibido em destaque no entenda o bônus, essa data exibe no padrão 10/01/19
export const GOL_BONUS_MAX_PRICE = 26.3; // Valor de bônus que atualmente é de R$ 20,00
export const GOL_BONUS_START_AVERAGE = 12000; // Se alterar essa variável terá que ajustar o layout do Slider pra ficar posicionado correto
export const GOL_BONUS_END_AVERAGE = 21000; // Se alterar essa variável terá que ajustar o layout do Slider pra ficar posicionado correto
export const GOL_BONUS_BEST_AVERAGE = 17000;

export const MANAGER_LIMIT_AVERAGE_MILES = 25000;

export const MINIMAL_MILES_ADVANCED_AVERAGE = 20000;

export const MINIMAL_MILES_SMILES_REDUCTIONS = 35000;

export const AIRLINE_PROGRAMS = {
	PLATINUM: {
		id: 1,
		name: "Platinum / Black",
	 	company: "Latam"
	},
	LATAM_PASS: {
		id: 3,
		name: "Latam Pass",
		company: "Latam"
	},
	SMILES: {
		id: 4,
		name: "Smiles",
		company: "Gol"
	},
	TUDO_AZUL: {
		id: 5,
		name: "Tudo Azul",
		company: "Azul"
	},
	TAP: {
		id: 21,
		name: "TAP Miles&Go",
		company: "TAP"
	}
}
